import { useEffect, useRef } from 'react'

const LIMITE_MS = 10 * 60 * 1000
// mousemove por sí solo puede disparar decenas de eventos por segundo; sin
// throttle, reiniciar el temporizador en cada uno sería puro desperdicio.
const THROTTLE_MS = 1000
const EVENTOS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart']

/**
 * Cierra la sesión tras 10 minutos sin interacción del usuario. Solo escucha
 * mientras `activo` es true (hay sesión iniciada) — nadie de paso por el
 * sitio sin sesión necesita estos listeners.
 */
export function useCierreSesionPorInactividad(activo, alExpirar) {
  const alExpirarRef = useRef(alExpirar)
  alExpirarRef.current = alExpirar

  useEffect(() => {
    if (!activo) return

    let temporizador
    let ultimoReinicio = 0

    const reiniciar = () => {
      const ahora = Date.now()
      if (ahora - ultimoReinicio < THROTTLE_MS) return
      ultimoReinicio = ahora
      clearTimeout(temporizador)
      temporizador = setTimeout(() => alExpirarRef.current(), LIMITE_MS)
    }

    reiniciar()
    EVENTOS.forEach((evento) => window.addEventListener(evento, reiniciar, { passive: true }))

    return () => {
      clearTimeout(temporizador)
      EVENTOS.forEach((evento) => window.removeEventListener(evento, reiniciar))
    }
  }, [activo])
}
